"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.error.fetch': 'Error al cargar los registros.',
};
